import {
  getCookie,
  isConsentCategoryEnabled,
  OneTrustCategories,
} from '@susu/cookie'

/**
 * Get Google and Facebook attributes from cookies
 * @returns {fbFbc: string, fbFbp: string, gaAwClid: string}
 */
export const getGoogleAndFacebookAttributesFromCookies = (): {
  fbFbc: string
  fbFbp: string
  gaAwClid: string
} => {
  if (!isConsentCategoryEnabled(OneTrustCategories.ADVERTISING)) {
    return { fbFbc: '', fbFbp: '', gaAwClid: '' }
  }

  const fbFbc = getCookie('_fbc') ?? ''
  const fbFbp = getCookie('_fbp') ?? ''
  const gaAwClid = getCookie('_gcl_aw')?.split('.')[2] ?? ''

  return { fbFbc, fbFbp, gaAwClid }
}
